import { render, staticRenderFns } from "./ContactButtonMobile.vue?vue&type=template&id=20d26a85"
import script from "./ContactButtonMobile.vue?vue&type=script&lang=js"
export * from "./ContactButtonMobile.vue?vue&type=script&lang=js"
import style0 from "./ContactButtonMobile.vue?vue&type=style&index=0&id=20d26a85&prod&scroped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports